import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripMailTags'
})

export class StripMailTagslPipe implements PipeTransform {
    transform(value: string, getHeaderImage: boolean = false): any {

        value = value.replace(/(\[UnsubscribeFooter\].*\[\/UnsubscribeFooter\]|\[HeaderImage\].*\[\/HeaderImage\])/gi, "");

        return value;
    }
}
